import {
    GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS,
    GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED,
    RESET_GETMULTIPLEMAPPINGLISTFORPARTNER,
    LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER,
    NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetGETMULTIPLEMAPPINGLISTFORPARTNER = () => {
    return { type: RESET_GETMULTIPLEMAPPINGLISTFORPARTNER };
};

const partnerGetMultipleMappingListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMULTIPLEMAPPINGLISTFORPARTNER });
    await partnerServices
        .post("getMultipleMappingList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerGetMultipleMappingListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetMultipleMappingListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMULTIPLEMAPPINGLISTFORPARTNER,
                payload: err
            });
        });
};

function partnerGetMultipleMappingListsuccess(data) {
    return {
        type: GETMULTIPLEMAPPINGLISTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerGetMultipleMappingListFailed(data) {
    return {
        type: GETMULTIPLEMAPPINGLISTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetGETMULTIPLEMAPPINGLISTFORPARTNER, partnerGetMultipleMappingListReq }